import { SUPPORTED_LANGUAGES } from '../config';

// Создает регулярное выражение для поиска кода поддерживаемого языка в любой строке.
// Можно использовать для проверки наличия языка в URL
export const supportedLanguagesRegExp = RegExp(
  `^(${Object.keys(SUPPORTED_LANGUAGES)
    .map((l) => `\\/${l}($|/)`)
    .join('|')})`
);
